'use client';
import Button from '@/components/Button';
import Hero from '@/components/Hero';
import { formatDate } from '@/helpers/stringFormatHelper';
import { fetchHistoriqueDAchats } from '@/services/achats';
import Errors from '@/services/errors';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import { ConnectedStateContext, ToastContext } from './Layout';

const literals = {
  receiptLink: '/receipts',
};
const HistoriqueDAchat = () => {
  const updateToast = useContext(ToastContext);

  const [isConnected] = useContext(ConnectedStateContext);
  const [tirages, setTirages] = useState([]);
  const calculatedLink = (id) => {
    return literals.receiptLink + '?tirageId=' + id;
  };

  const fetchTiragesl = async () => {
    try {
      const result = await fetchHistoriqueDAchats();
      if (result instanceof Error) throw result;
      setTirages(result.tirageAchats);
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    if (isConnected) fetchTiragesl();
  }, [isConnected]);

  return (
    <>
      {/*m-1 m-md-2 m-lg-4*/}
      <div className="mb-2 mt-md-4  card card-1 sales-card">
        <div className="card-body p-0">
          <Hero title={'Historique d\'achats'} />
        </div>
      </div>
      {isConnected && (
        <>
          <div className="card card-3-light mb-3 py-3">
            <div className="card-tiltle">
              <h2 className={'text-center fw-bold'}>Tirages</h2>
            </div>
            <div className="card-body">
              <div className="row justify-content-center">
                {tirages.map((tirage, index) => (
                  <div className=" col-12 col-md-6 col-lg-4  col-xl-3 px-md-3 mb-3" key={index}>
                    <div className="bg-body-tertiary rounded-4 p-4">
                      <h3 className={'text-center'}> Tirage du : {formatDate(tirage.dateTirage)}</h3>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-4">Tirage :</div>
                        <div className="col-6">{tirage.description}</div>
                      </div>
                      <div className="row">
                        <div className="col-2"></div>
                        <div className="col-4">Montant :</div>
                        <div className="col-6">{tirage.montant}$</div>
                      </div>
                      <div className="row justify-content-center">
                        <Link href={calculatedLink(tirage.id)} className={'col-auto'}>
                          <Button className="btn btn-primary mt-3">Voir les Recus</Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HistoriqueDAchat;
